import {checkmarkCircleOutline, closeCircleOutline, warningOutline} from "ionicons/icons";
import {i18n} from "@/plugins/i18n";
import {IDocumentStatus} from "@/interfaces/IDocumentStatus";
import {DOCUMENT_VERIFICATION_STATUSES} from "@/utils/constants/general-constants";

export const fileSize = (size: number) => {
  return (size / 1024).toFixed(0) + ' KB';
};

/**
 * Capitalize utility functions for strings.
 */

/**
 * Capitalizes the first character of the string.
 * @param str The string to capitalize.
 * @returns The capitalized string.
 */
export function capitalizeFirstLetter(str: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Capitalizes the first letter of each word in the string.
 * @param str The string to capitalize.
 * @returns The string with each word capitalized.
 */
export function capitalizeEachWord(str: string): string {
  if (!str) return '';
  return str
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ');
}

/**
 * Converts the entire string to uppercase.
 * @param str The string to convert.
 * @returns The uppercase string.
 */
export function toUpperCase(str: string): string {
  return str.toUpperCase();
}

/**
 * Converts the entire string to lowercase.
 * @param str The string to convert.
 * @returns The lowercase string.
 */
export function toLowerCase(str: string): string {
  return str.toLowerCase();
}

export function generateUniqueId(prefix: string = 'id'): string {
  return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
}

export const getStatusMessage = (status: string): IDocumentStatus => {

  switch (status) {
    case DOCUMENT_VERIFICATION_STATUSES.PENDING:
      return {
        color: 'warning',
        icon: warningOutline,
        title: i18n.global.t('files.status.pending'),
      };
    case DOCUMENT_VERIFICATION_STATUSES.REJECTED:
      return {
        color:'danger',
        icon: closeCircleOutline,
        title: i18n.global.t('files.status.rejected'),
      };
    case DOCUMENT_VERIFICATION_STATUSES.SIGNED_BY_OWNER:
      return {
        color: 'warning',
        icon: warningOutline,
        title: i18n.global.t('files.status.signedByOwner'),
      };
    case DOCUMENT_VERIFICATION_STATUSES.SIGNED_BY_TENANT_AND_OWNER:
      return {
        color: 'success',
        icon: checkmarkCircleOutline,
        title: i18n.global.t('files.status.verified'),
      };
    case DOCUMENT_VERIFICATION_STATUSES.PENDING_ACCEPTANCE_OR_REVIEW:
      return {
        color: 'warning',
        icon: closeCircleOutline,
        title: i18n.global.t('files.status.pendingAcceptanceOrReview'),
      };
    case DOCUMENT_VERIFICATION_STATUSES.NOT_VALIDATED:
      return {
        color: 'warning',
        icon: closeCircleOutline,
        title: i18n.global.t('files.status.not_validated'),
      };
    case DOCUMENT_VERIFICATION_STATUSES.VALIDATED:
      return {
        color: 'success',
        icon: checkmarkCircleOutline,
        title: i18n.global.t('files.status.validated'),
      };
    default:
      return {
        color: 'warning',
        icon: warningOutline,
        title: i18n.global.t('files.status.pending'),
      };
  }

}
